import { render, staticRenderFns } from "./productMoaTable.vue?vue&type=template&id=72b12fe0&"
import script from "./productMoaTable.vue?vue&type=script&lang=js&"
export * from "./productMoaTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports